import React, { useState, useEffect } from "react";
import "./Sidebar.css";
import { useLocation } from "react-router-dom";
import { useUser } from "../contexts/UserContext";

// SVGアイコンの定義
const SVGIcons = {
  goal: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="28.001"
      viewBox="0 0 19 28.001"
    >
      <path
        id="前面オブジェクトで型抜き_6"
        data-name="前面オブジェクトで型抜き 6"
        d="M3.421,28h0V20.713a11.8,11.8,0,0,0,12.158,0V28L9.5,25.9,3.421,28ZM9.5,19.6h0a8.965,8.965,0,0,1-1.39-.119A9.157,9.157,0,0,1,6.53,19.1l-.069-.027A9.352,9.352,0,0,1,3.909,17.7h0a9.616,9.616,0,0,1-1.644-1.571,9.828,9.828,0,0,1-1.227-1.9A10.034,10.034,0,0,1,0,9.8,9.664,9.664,0,0,1,9.5,0a9.22,9.22,0,0,1,4.718,1.3L8.925,6.757l1.319,1.361,5.512-5.687a9.794,9.794,0,0,1,1.485,1.7L11.809,9.732l1.32,1.361L18.2,5.862a10.086,10.086,0,0,1,.318,7.021,9.866,9.866,0,0,1-1.344,2.682,9.728,9.728,0,0,1-2.048,2.119,9.406,9.406,0,0,1-2.6,1.4l-.057.022a9.409,9.409,0,0,1-1.331.34l-.247.039A9.081,9.081,0,0,1,9.5,19.6Z"
        transform="translate(0)"
        fill="currentColor"
      />
    </svg>
  ),
  attendance: (
    <svg
      id="グループ_47"
      data-name="グループ 47"
      xmlns="http://www.w3.org/2000/svg"
      width="19.819"
      height="36.338"
      viewBox="0 0 19.819 36.338"
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="長方形_31"
            data-name="長方形 31"
            width="19.819"
            height="36.338"
            fill="currentColor"
          />
        </clipPath>
      </defs>
      <g id="グループ_27" data-name="グループ 27" clipPath="url(#clipPath)">
        <path
          id="パス_55"
          data-name="パス 55"
          d="M7.543,24.415.727,20.55a2.325,2.325,0,0,1-.639-1.419,38.258,38.258,0,0,1,0-5.253,3.29,3.29,0,0,1,1.725-2.461l6.26-1.759L8.11,1.813A2.146,2.146,0,0,1,11.09.182c2.384,1.422,5,2.62,7.358,4.067A2.337,2.337,0,0,1,19.82,6l-.009,7.834L9.243,17.706a3.44,3.44,0,0,0-1.7,2.487ZM2.22,14.019c-.123.691.091,1.718,0,2.448L7.679,13.3a1.594,1.594,0,0,0,.431-1.378c-1.578.429-3.266.732-4.825,1.242-.426.14-.973.333-1.065.851"
          transform="translate(0 0)"
          fill="currentColor"
        />
        <path
          id="パス_56"
          data-name="パス 56"
          d="M24.959,191.306l4.284-1.926a1.753,1.753,0,0,1,2.107-1.094,1.619,1.619,0,0,1,.209,2.984,2.27,2.27,0,0,1-1.418.066l-3.62,1.708,3.683,1.7a1.612,1.612,0,1,1-.9,1.947l-5.379-2.475-5.313,2.416c-.491.828-1.088,1.417-2.133,1.122-2.068-.582-.977-3.891,1.173-3.012l3.683-1.7-3.619-1.709a1.792,1.792,0,0,1-2.16-.744c-1.115-2.052,2.225-3.466,2.989-1.2l4.28,1.911v-3.833a3.834,3.834,0,0,0,2.129-.568Z"
          transform="translate(-13.159 -162.938)"
          fill="currentColor"
        />
        <path
          id="パス_57"
          data-name="パス 57"
          d="M78.291,113.528v2.235a3.465,3.465,0,0,1-1.254,2.01c-2.528,1.393-5.017,3.179-7.569,4.495a2.425,2.425,0,0,1-1.325.414v-4.861c0-.366.505-.837.853-.921Z"
          transform="translate(-58.472 -97.415)"
          fill="currentColor"
        />
        <path
          id="パス_58"
          data-name="パス 58"
          d="M15.407,88.569c.091-.73-.123-1.757,0-2.448"
          transform="translate(-13.186 -72.101)"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  skills: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.033"
      height="25.009"
      viewBox="0 0 18.033 25.009"
    >
      <path
        id="前面オブジェクトで型抜き_7"
        data-name="前面オブジェクトで型抜き 7"
        d="M-11325.261-10190.991h0l-11.738-7.3v-13.968a2.179,2.179,0,0,1,.373-1.306,6.375,6.375,0,0,1,4.57-2.432,2.226,2.226,0,0,1,1.046.229l12.044,6.226v15.1l-2.214,1.206v-15.1l-10.734-5.741a1.545,1.545,0,0,0-.536-.091,3.946,3.946,0,0,0-2.653,1.5l4.119,2.366v8l2.282-1.295,2.72,4.422v-8.257l2.928,1.682v13.555l-2.205,1.206Z"
        transform="translate(11337 10216)"
        fill="currentColor"
      />
    </svg>
  ),
  userSettings: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.266"
      height="22.285"
      viewBox="0 0 22.266 22.285"
    >
      <g id="user-avatar-filled" transform="translate(-12 -11.98)">
        <path
          id="パス_104"
          data-name="パス 104"
          d="M31.694,30.23a11.141,11.141,0,1,0-17.109,0l-.014.015c.056.067.119.124.177.19.072.082.149.159.223.239.223.242.452.474.692.692.073.067.149.129.223.193.255.22.516.428.788.622.035.024.067.055.1.08v-.01a11.062,11.062,0,0,0,12.732,0v.01c.035-.025.066-.056.1-.08q.406-.292.788-.622c.074-.064.15-.127.223-.193.24-.219.47-.45.692-.692.074-.08.15-.157.223-.239.056-.066.121-.123.177-.191ZM23.141,16.757a3.581,3.581,0,1,1-3.581,3.581,3.581,3.581,0,0,1,3.581-3.581ZM16.78,30.23a3.976,3.976,0,0,1,3.973-3.923h4.775A3.976,3.976,0,0,1,29.5,30.23,9.5,9.5,0,0,1,16.78,30.23Z"
          transform="translate(0 0)"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
};

const Sidebar: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false); // サイドバーの開閉状態
  const location = useLocation(); // 現在のURLを取得
  const { authUser } = useUser();
  const userId = authUser?.id || null;

  // 各ベースパスを定義
  const BASE_PATHS = [
    `${process.env.REACT_APP_VUE_FRONTEND_URL}/tassei`,
    `${process.env.REACT_APP_VUE_FRONTEND_URL}/ors`,
    `${process.env.REACT_APP_REACT_FRONTEND_URL}/tf`,
    `${process.env.REACT_APP_REACT_FRONTEND_URL}/main`,
  ];

  // ナビゲーションアイコンリスト
  const navItems = [
    {
      href: `${process.env.REACT_APP_VUE_FRONTEND_URL}/tassei/home`,
      icon: SVGIcons.goal,
      label: "目標管理",
    },
    {
      href: `${process.env.REACT_APP_VUE_FRONTEND_URL}/ors/home`,
      icon: SVGIcons.attendance,
      label: "出社予約",
    },
    {
      href: `${process.env.REACT_APP_REACT_FRONTEND_URL}/tf/user-sheets`,
      icon: SVGIcons.skills,
      label: "スキルマネジメント",
    },
    {
      href: `${process.env.REACT_APP_REACT_FRONTEND_URL}/main/profile/${userId}`,
      icon: SVGIcons.userSettings,
      label: "ユーザー設定",
    },
  ];

  // 現在のURLが特定のベースパスに一致するか確認
  const isActive = (href: string) => {
    const currentPath = `${window.location.origin}${location.pathname}`; // フルパスを取得
    const basePath = BASE_PATHS.find((path) => href.startsWith(path)); // 現在のhrefに一致するベースパスを取得
    return basePath ? currentPath.startsWith(basePath) : false; // 一致するベースパスがあり、かつcurrentPathがそのベースパスで始まるか判定
  };

  return (
    <aside
      className={`sidebar ${isExpanded ? "expanded" : ""}`}
      // ★ マウスオーバーで開く
      onMouseEnter={() => setIsExpanded(true)}
      // ★ マウスが外れたら閉じる
      onMouseLeave={() => setIsExpanded(false)}
    >
      {/* システムアイコン */}
      <div className={`sidebar-system ${isExpanded ? "with-underline" : ""}`}>
        <img src="/logo.svg" alt="システムアイコン" className="system-icon" />
        {isExpanded && <span className="system-label">iSopra Cloud</span>}
      </div>

      {/* ナビゲーションアイコン */}
      <nav className="sidebar-navigation">
        {navItems.map((item) => (
          <a
            key={item.href}
            href={isExpanded ? item.href : undefined} // ★ 展開時のみリンク有効
            className={`sidebar-nav-item ${
              isActive(item.href) ? "active" : ""
            }`}
          >
            {item.icon}
            {isExpanded && <span className="nav-label">{item.label}</span>}
          </a>
        ))}
      </nav>

      {/* 折りたたみアイコン（見た目だけ。クリックではトグルしない） */}
      <div className="sidebar-collapse">
        <img
          src="/accordion.svg"
          alt="折りたたみ"
          className={`collapse-icon ${isExpanded ? "rotated" : ""}`}
        />
      </div>
    </aside>
  );
};

export default Sidebar;
